import React from "react";

function TermsConditions() {
  return (
    <div className="policy-page container">
      <style>{`
        .policy-page {
          max-width: 900px;
          margin: 0 auto;
          padding: 50px 20px;
          font-family: "Helvetica Neue", Arial, sans-serif;
          color: #333;
          line-height: 1.8;
        }
        .policy-title {
          font-size: 2.2rem;
          text-align: center;
          margin-bottom: 10px;
          color: #2c2c2c;
        }
        .last-updated {
          text-align: center;
          color: #777;
          margin-bottom: 40px;
          font-size: 0.9rem;
        }
        .policy-page section {
          margin-bottom: 40px;
        }
        .policy-page h2 {
          font-size: 1.4rem;
          color: #444;
          margin-bottom: 15px;
          border-left: 4px solid #d19c65; /* Accent color */
          padding-left: 10px;
        }
        .policy-page p {
          font-size: 1rem;
          margin-bottom: 15px;
        }
        .policy-page ul {
          list-style: disc inside;
          margin-top: 10px;
        }
        .policy-page li {
          margin-bottom: 8px;
          font-size: 1rem;
        }
        @media (max-width: 768px) {
          .policy-page {
            padding: 30px 15px;
          }
          .policy-title {
            font-size: 1.8rem;
          }
          .policy-page h2 {
            font-size: 1.2rem;
          }
        }
      `}</style>

      <h1 className="policy-title">Terms & Conditions</h1>
      {/* <p className="last-updated">Last updated: September 11, 2025</p> */}

      <section>
        <h2>Introduction</h2>
        <p>
          By accessing or using our website and services, you agree to be bound
          by these Terms & Conditions. Please read them carefully before making
          any purchase or using our services.
        </p>
      </section>

      <section>
        <h2>Eligibility</h2>
        <p>
          You must be at least 18 years old to make a purchase on our website.
          By placing an order, you confirm that you meet this requirement.
        </p>
      </section>

      <section>
        <h2>Account Responsibility</h2>
        <p>
          If you create an account, you are responsible for maintaining the
          confidentiality of your login details and for all activities under
          your account.
        </p>
      </section>

      <section>
        <h2>Product Information</h2>
        <p>
          We make every effort to ensure product details, descriptions, and
          prices are accurate. However, errors may occur, and we reserve the
          right to correct them without prior notice.
        </p>
      </section>

      <section>
        <h2>Pricing & Payments</h2>
        <p>
          All prices are listed in INR (₹) unless stated otherwise. Payments
          must be made in full at the time of purchase through our secure
          payment gateways.
        </p>
      </section>

      <section>
        <h2>Shipping & Delivery</h2>
        <p>
          Orders will be processed and shipped according to our Shipping Policy.
          Delivery timelines are estimates and may vary.
        </p>
      </section>

      <section>
        <h2>Returns & Refunds</h2>
        <p>
          Returns and refunds are governed by our Refund Policy. Please refer to
          that policy for full details.
        </p>
      </section>

      <section>
        <h2>Limitation of Liability</h2>
        <p>
          We are not liable for any indirect, incidental, or consequential
          damages arising from your use of our services or products.
        </p>
      </section>

      <section>
        <h2>Changes to Terms</h2>
        <p>
          We may update or modify these Terms & Conditions at any time without
          prior notice. Continued use of our website implies acceptance of the
          revised terms.
        </p>
      </section>

      {/* <section>
        <h2>Contact Us</h2>
        <p>
          For questions about these Terms & Conditions, please contact our
          support team:
        </p>
        <ul>
          <li>Email: support@yourwebsite.com</li>
          <li>Phone: +91-XXXXXXXXXX</li>
        </ul>
      </section> */}
    </div>
  );
}

export default TermsConditions;
